import React from 'react'
import ReactDOM from 'react-dom'
import Newsletter from 'misc/email_signup/newsletter.jsx'

document.addEventListener('DOMContentLoaded', () => {
  const mount = document.getElementById('newsletter-signup')
  ReactDOM.render(<Newsletter />, mount)
})
